<template>
<div>
  <!-- <a-tabs  :activeKey="customActiveKey" :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }">
    <a-tab-pane key="tab1" tab="注册"> -->
      <a-form-model ref="ruleform" :model="model" :rules="validatorRules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item prop="username" label="用户名" >
        <a-input v-model="model.username" size="large" type="text" autocomplete="false" placeholder="请输入用户名" />
      </a-form-model-item>

      <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
            <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor "/>
            <div style="margin-top: 10px;">
              <span>请至少输入 8 个字符。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>
        <a-form-model-item prop="password" label="密码">
          <a-input
            v-model="model.password"
            size="large"
            type="password"
            @click="handlePasswordInputClick"
            autocomplete="false"
            placeholder="至少8位密码，区分大小写">
          </a-input>
        </a-form-model-item>
      </a-popover>

      <a-form-model-item prop="password2" label="确认密码">
        <a-input v-model="model.password2" size="large" type="password" autocomplete="false" placeholder="确认密码"></a-input>
      </a-form-model-item>

      <a-form-model-item prop="realname" label="姓名">
        <a-input v-model="model.realname" size="large" type="text" autocomplete="false" placeholder="请输入姓名"/>
      </a-form-model-item>

      <a-form-model-item prop="cmpname" label="单位名称">
        <a-input v-model="model.cmpname" size="large" type="text" autocomplete="false" placeholder="请输入单位名称"/>
      </a-form-model-item>

      <a-form-model-item prop="phone" label="电话">
        <a-input v-model="model.phone" size="large" type="text" autocomplete="false" placeholder="请输入电话"/>
      </a-form-model-item>

      <!-- <a-row :gutter="0">
        <a-col :span="18"> -->
          <a-form-model-item prop="inputCode" label="验证码">
            <a-input v-model="model.inputCode" size="large" type="text" placeholder="请输入验证码" style="width:280px">
              <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
            <img v-if="requestCodeSuccess" style="margin-top: 2px;float:right" :src="randCodeImage" @click="handleChangeCheckCode" />
            <img v-else style="margin-top: 2px;float:right" src="../../../images/checkcode.png" @click="handleChangeCheckCode"/>
          </a-form-model-item>
        <!-- </a-col>
        <a-col :span="2" > -->

        <!-- </a-col>
      </a-row> -->


    </a-form-model>
    <!-- </a-tab-pane> -->
    <!-- <a-tab-pane key="2" tab="验证码登录" force-render>Content of Tab Pane 2</a-tab-pane> -->
  <!-- </a-tabs> -->
  <a-form-model-item style="margin-top:24px;margin-left:30px">
    <a-button size="large"  type="primary"   class="login-button" style="width:90%;background:#00488a;border:#00488a"   @click="handleSubmit" >注册
    </a-button>
  </a-form-model-item>
  <a-form-model-item style="margin-top:24px;margin-left:30px">
    <a-button size="large"  type="primary"   class="login-button" style="width:90%;background:#00488a;border:#00488a"   @click="cancel" >取消
    </a-button>
  </a-form-model-item>
  </div>
</template>
<script>
import http from '../../../js/axios'
const levelNames = {
    0: '低',
    1: '低',
    2: '中',
    3: '强'
  }
  const levelColor = {
    0: '#ff0000',
    1: '#ff0000',
    2: '#ff7e05',
    3: '#52c41a',
  }
  const levelClass = {
    0: 'error',
    1: 'error',
    2: 'warning',
    3: 'success'
  }

export default {
  components: {
    },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      requestCodeSuccess: false,
      randCodeImage: '',
      currdatetime: '',
      login:1,
      activeKey:['1'],
      customActiveKey: 'tab1',
      rememberMe: true,
      registerBtn: false,
      model: {
        inputCode:''},
      validatorRules: {
        username: [
          { required: true,message:'请输入用户名！' },
          { validator: this.checkUsername }
        ],
        password: [
          { required: true,message:'请输入密码！'},
          { validator: this.handlePasswordLevel }
        ],
        password2: [
          { required: true,message:'请输入确认密码！'},
          { validator: this.handlePasswordCheck }
        ],
        cmpname:[
          { required: true,message:'请输入单位名称！' },
        ],
        phone:[
          { required: true,message:'请输入电话！' },
          { validator: this.checkPhone }
        ],
        inputCode: [{
          required: true, message: '请输入验证码!'
        }],
        realname:[
          { required: true,message:'请输入姓名！' },
        ],
      },
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      error:'',
      cfphone:''
    };
  },
  computed:{
    passwordLevelClass() {
        return levelClass[this.state.passwordLevel]
      },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel]
    }
  },
  created() {
      this.handleChangeCheckCode();
    },
  methods: {
    cancel(){
      this.model = {}
      this.$emit('clear')
    },
    handleChangeCheckCode(){
        this.currdatetime = new Date().getTime();
        this.model.inputCode = ''
        http.get(`/randomImage/${this.currdatetime}`
        ).then((res) => {
            this.randCodeImage = res.data.result
            this.requestCodeSuccess=true
        })
      },
    handlePasswordInputClick() {
          this.state.passwordLevelChecked = true
          this.state.passwordLevelChecked = false
          return;

      },
      checkPhone (rule, value, callback) {
        this.queryuserphone(value)
        // !(/^1[34578]\d{9}$/.test(value))
         if (!(/^1[345789]\d{9}$/.test(value))) {
           callback(new Error('请输入正确的手机号码!'));
         }else if(this.cfphone==false){
          callback("手机号已存在!")
        }else{
          callback()
        }
    },
    handlePasswordCheck(rule, value, callback) {
        let password = this.model['password']
        //console.log('value', value)
        if (value === undefined) {
          callback(new Error('请输入密码'))
        }else
        if (value!=this.model.password) {
          callback(new Error('两次密码不一致'))
        }else{
          callback()
        }
      },
    checkUsername(rule, value, callback) {
        this.queryuser(value)
        if(!value){
          callback(new Error("请输入用户名"))
        }else if(/[\u4E00-\u9FA5]/g.test(value)){
          callback(new Error("不能输入汉字"))
        }
        else if(this.error==false){
          callback("用户名已存在!")
        }else{
          callback()
        }
    },
    queryuserphone(value){
      http.get('/checkOnlyPhone',{params:{phone:value}}).then((res) => {
        this.cfphone=res.data.success
      })
    },
    queryuser(value){
      http.get('/checkOnlyUser',{params:{username:value}}).then((res) => {
        this.error=res.data.success
      })
    },
    handlePasswordLevel(rule, value, callback) {
        let level = 0
        let reg = /^(\w){8,20}$/;
        if (!reg.test(value)) {
          callback(new Error('密码长度8到20位!'))
        } else {
          callback()
        }
      /*  if (value.length < 8) {
          callback(new Error('密码至少8位!'))
        }*/
        // 判断这个字符串中有没有数字
     /*   if (/[0-9]/.test(value)) {
          level++
        }
        // 判断字符串中有没有字母
        if (/[a-zA-Z]/.test(value)) {
          level++
        }
        level++
        // 判断字符串中有没有特殊符号
       /!* if (/[^0-9a-zA-Z_]/.test(value)) {
          level++
        }*!/
        this.state.passwordLevel = level
        this.state.percent = level * 30
        if (level >= 2) {
          if (level >= 3) {
            this.state.percent = 100
          }
          callback()
        } else {
          if (level === 0) {
            this.state.percent = 10
          }
          callback(new Error('密码强度不够'))
        }*/
      },
      //注册
      handleSubmit () {
        this.registerBtn = true;
        this.$refs.ruleform.validate(valid => {
          if (valid) {
            let values = this.model
            let register = {
              username: values.username,
              password: values.password,
              realname:values.realname,
              cmpname:values.cmpname,
              phone: values.phone,
              captcha: values.inputCode,
              checkKey: this.currdatetime,
            };
            http.register(register
            ).then((res) => {
                if(res.data.success==true){
                  //this.$message.success("注册成功！")
                  this.$notification.success({
                    message: '注册成功',
                    description: '请等待管理员审核后方可申请标准',
                    duration: 30
                  });
                  let loginParams = {
                    username: values.username,
                    password: values.password,
                  }
                  http.loginzc(loginParams
                  ).then((res) => {
                      if(res.data.success==true){
                        this.model = {}
                        this.$emit('ok')
                      }else{
                        this.$message.error(res.data.message)
                      }
                  }).catch((err) => {
                    this.$emit('fail', err)
                  });
                }else{
                  this.$message.error(res.data.message)
                  // this.$message.error("手机号已存在，注册失败！")
                }
            })
          }
        })
      },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/login/moudles/RegisterForm.vue